export const ALL_LOCATIONS_ENABLED_STRING = 'all-locations-enabled';

export const validateLocationsArray = (locations: string[]): void => {
  if (!Array.isArray(locations)) {
    throw new Error(
      'Invalid type: Expected an array of strings for enabled locations'
    );
  }

  for (const location of locations) {
    if (typeof location !== 'string') {
      throw new Error('Invalid type: Expected all elements to be strings');
    }
  }
};

export const isAllLocationsEnabled = (parsedLocations: string[]): boolean => {
  return parsedLocations.includes(ALL_LOCATIONS_ENABLED_STRING);
};

export const isCurrentLocationEnabled = (
  parsedLocations: string[],
  currentLocationExternalId: string
): boolean => {
  return parsedLocations.includes(currentLocationExternalId);
};
